define(
	'Tavanoteam.TavanoTeam_Home_Extension.HomeElements.View'
	, [
		'SCView',
		'homeelements.tpl'
	]
	, function (
		SCViewModule,
		homeelements_tpl
	) {

    'use strict';

    var SCView = SCViewModule.SCView;

    function TavanoTeamHomeExtension(options) {
        SCView.call(this, options);

        this.template = homeelements_tpl;

        this.sections = options.sections;
    }

    TavanoTeamHomeExtension.prototype = Object.create(SCView.prototype);
    TavanoTeamHomeExtension.prototype.constructor = TavanoTeamHomeExtension;

    TavanoTeamHomeExtension.prototype.getContext = function () {
        return {
            sections: this.sections
        };
    };

    return TavanoTeamHomeExtension;
});
